// extracted by mini-css-extract-plugin
export default {"heroWrapper":"Hero_heroWrapper__lkR4V","image":"Hero_image__zL6bt","sloganWrapper":"Hero_sloganWrapper__DnpYC","slogan":"Hero_slogan__5Hr8P","lines":"Hero_lines__-GTcG"};